import { useMemo } from "react";
import { usePathname } from "next/navigation";
import { findRouteByPathname } from "@/config/navigation";

export function usePageInfo() {
  const pathname = usePathname() ?? "/";
  const route = useMemo(
    () => findRouteByPathname(pathname),
    [pathname]
  );

  return { ...route };
}
